import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';

const inputCls = "bg-white/5 border-border text-foreground";

const YesNo = ({ label, sublabel, value, onChange }) => (
  <div className="space-y-1.5">
    <p className="text-sm text-foreground font-medium">{label}</p>
    {sublabel && <p className="text-xs text-muted-foreground">{sublabel}</p>}
    <div className="flex items-center gap-4">
      {['No', 'Yes'].map(opt => (
        <button key={opt} type="button" onClick={() => onChange(opt)} className="flex items-center gap-2 cursor-pointer">
          <div className={cn(
            "w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors",
            value === opt ? 'border-primary bg-primary' : 'border-border'
          )}>
            {value === opt && <div className="w-1.5 h-1.5 rounded-full bg-primary-foreground" />}
          </div>
          <span className="text-sm text-foreground">{opt}</span>
        </button>
      ))}
    </div>
  </div>
);

export default function StepDrivingRecord({ form, set }) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-space font-semibold text-foreground text-base">Experience & Driving Record</h3>
        <p className="text-xs text-muted-foreground mt-0.5">Previous 3 years — required by 49 CFR 391.21</p>
      </div>

      <div className="space-y-1 text-xs text-muted-foreground px-3 py-2.5 rounded-lg bg-muted/40 border border-border">
        <p>No person who operates a commercial motor vehicle shall at any time have more than one driver's license (49 CFR 383.21). I certify that I do not have more than one motor vehicle license.</p>
      </div>

      {/* Accidents */}
      <div className="rounded-xl border border-border bg-muted/40 p-4 space-y-4">
        <p className="text-xs font-semibold text-primary uppercase tracking-widest">Accidents / Crashes — Previous 3 Years</p>
        <YesNo
          label="Have you had any accidents/crashes in the last 3 years?"
          value={form.accidents}
          onChange={v => set('accidents', v)}
        />
      </div>

      {/* Violations */}
      <div className="rounded-xl border border-border bg-muted/40 p-4 space-y-4">
        <p className="text-xs font-semibold text-primary uppercase tracking-widest">Moving Traffic Violations — Previous 3 Years</p>
        <YesNo
          label="Have you had any moving traffic violations in the last 3 years?"
          value={form.violations}
          onChange={v => set('violations', v)}
        />
      </div>

      {/* Forfeitures */}
      <div className="rounded-xl border border-border bg-muted/40 p-4 space-y-4">
        <p className="text-xs font-semibold text-primary uppercase tracking-widest">Forfeitures — Previous 3 Years</p>
        <YesNo
          label="A. Have you ever been denied a license, permit or privilege to operate a motor vehicle?"
          value={form.denied_license}
          onChange={v => set('denied_license', v)}
        />
        <YesNo
          label="B. Has any license, permit or privilege ever been suspended, revoked, or cancelled?"
          value={form.revoked_license}
          onChange={v => set('revoked_license', v)}
        />
        {(form.denied_license === 'Yes' || form.revoked_license === 'Yes') && (
          <div>
            <p className="text-xs text-muted-foreground mb-1">C. If yes to either above, briefly describe the circumstances:</p>
            <textarea
              value={form.forfeiture_explain}
              onChange={e => set('forfeiture_explain', e.target.value)}
              rows={3}
              placeholder="Describe the circumstances..."
              className="w-full px-3 py-2 rounded-lg bg-transparent border border-input text-foreground text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary/50 resize-none"
            />
          </div>
        )}
      </div>

      {/* Alcohol & Drug Statement */}
      <div className="rounded-xl border border-amber-500/20 bg-amber-500/5 p-4 space-y-2">
        <p className="text-xs font-semibold text-amber-400 uppercase tracking-widest">Pre-Employment Alcohol & Drug Statement</p>
        <p className="text-xs text-foreground leading-relaxed">
          49 CFR Part 40.25(j): Have you tested positive, or refused to test, on any pre-employment drug or alcohol test administered by an employer to which you applied for, but did not obtain, safety-sensitive transportation work covered by DOT agency drug and alcohol testing rules during the past two years?
        </p>
        <YesNo
          label="Have you had a positive drug/alcohol test or refusal in the last 2 years?"
          value={form.drug_test_positive}
          onChange={v => set('drug_test_positive', v)}
        />
        {form.drug_test_positive === 'Yes' && (
          <div className="px-3 py-2 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-xs">
            You must not be used to perform safety-sensitive functions until you document successful completion of the return-to-duty process required in 49 CFR Subpart O.
          </div>
        )}
      </div>
    </div>
  );
}